// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__g4MAo","actions":"GroupTable_actions__1bNmY","deleteModalFooter":"GroupTable_deleteModalFooter__19Y-I"};